// docs: https://github.com/altostra/type-validations#readme
import { anyOf, objectOf } from "@altostra/type-validations";
import { nullValidation, string } from "@altostra/type-validations/lib/primitives";

export const isCompaniesCompanyIdDevelopersCurrentPrefCenterUrlResult = objectOf({
  preference_center_url: anyOf(string, nullValidation),
});
